import styled from 'styled-components';

export const ScrollingAreaWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: auto;
    gap: ${({ gap }) => (gap ? gap : '0')};
    overflow-x: auto;
    box-sizing: border-box;
    padding: 0 16px;
    &::-webkit-scrollbar {
        display: none;
    }
`;
